WalletRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function WalletRouting($urlRouterProvider, $stateProvider) {
  $urlRouterProvider.otherwise("/Wallet/Dashboard");

  $stateProvider

    .state("Wallet", {
      abstract: true,

      url: "/Wallet",

      template: '<ui-view id="Wallet"></ui-view>'
    })

    .state("Wallet.Dashboard", {
      url: "/Dashboard",

      controller: "Wallet.DashboardController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./Dashboard/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./Dashboard/Dashboard.module");

              $ocLazyLoad.load({
                name: "DashboardModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },
      breadcrumbData: {
        title: "کیف پول",
        icon: "fas fa-money-bill"
      }
    })
    .state("Wallet.Transactions", {
      url: "/Transactions/:id",
      params: {
        id: '0'
      },
      controller: "Wallet.TransactionsController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./Transactions/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./Transactions/Transactions.module");

              $ocLazyLoad.load({
                name: "TransactionsModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },
      breadcrumbData: {
        parent: "Wallet.Dashboard",
        title: "تراکنش ها",
        icon: "fas fa-tasks"
      }
    })
    .state("Wallet.BankAccountList", {
      url: "/BankAccountList",

      controller: "Wallet.BankAccountListController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./BankAccountList/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./BankAccountList/BankAccountList.module");

              $ocLazyLoad.load({
                name: "BankAccountListModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },

      breadcrumbData: {
        parent: "Wallet.Dashboard",
        title: "مدیریت حساب ها",
        icon: "fas fa-cogs"
      }
    })
    .state("Wallet.BankAccountRequest", {
      url: "/BankAccountRequest",

      controller: "Wallet.BankAccountRequestController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./BankAccountRequest/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./BankAccountRequest/BankAccountRequest.module");

              $ocLazyLoad.load({
                name: "BankAccountRequestModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },

      breadcrumbData: {
        parent: "Wallet.BankAccountList",
        title: "ایجاد حساب",
        icon: "fas fa-plus"
      }
    })
    .state("Wallet.Callback", {
      url: "/Callback/:data",

      controller: "Wallet.CallbackController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./Callback/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./Callback/Callback.module");

              $ocLazyLoad.load({
                name: "CallbackModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      }
    })
    .state("Wallet.PayOffRequests", {
      url: "/PayOffRequests",

      controller: "Wallet.PayOffRequestsController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./PayOffRequests/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./PayOffRequests/PayOffRequests.module");

              $ocLazyLoad.load({
                name: "PayOffRequestsModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },
      breadcrumbData: {
        parent: "Wallet.Dashboard",
        title: "تسویه حساب",
        icon: "fas fa-handshake"
      }
    })
    .state("Wallet.TransactionDetail", {
      url: "/TransactionDetail/:Id/:type",

      controller: "Wallet.TransactionDetailController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./TransactionDetail/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./TransactionDetail/TransactionDetail.module");

              $ocLazyLoad.load({
                name: "TransactionDetailModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },
      breadcrumbData: {
        parent: "Wallet.Transactions",
        title: "جزئیات تراکنش",
        icon: "fa fa-info-circle"
      }
    })
    .state("Wallet.MyCredits", {
      url: "/MyCredits",

      controller: "Wallet.MyCreditsController",

      controllerAs: "self",

      templateProvider: [
        "$q",
        $q => {
          return $q(resolve => {
            require.ensure([], () => {
              let template = require("./MyCredits/views/index.html");

              resolve(template);
            });
          });
        }
      ],

      resolve: {
        Lazyload: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            let deferred = $q.defer();

            require.ensure([], function () {
              let module = require("./MyCredits/MyCredits.module");

              $ocLazyLoad.load({
                name: "MyCreditsModule"
              });

              deferred.resolve(module);
            });

            return deferred.promise;
          }
        ]
      },
      breadcrumbData: {
        parent: "Wallet.Dashboard",
        title: "اعتبارات من",
        icon: "fas fa-wallet"
      }
    }) /*endOfResolve*/ ;
}

export default WalletRouting;